import { batch } from 'react-redux';
import { setup } from 'utils/jwtToken';
import { dispatchContactId } from '@hydrogen/elements.data.wealth.app.use-contact-id';
import authSlice from './authSlice';

export const {
    setUser, setError, setLoading,
    resetUser,
} = authSlice.actions;

export const authenticateUser = (loginData) => async (dispatch) => {
    dispatch(setLoading(true));

    const stopWithException = (error) => {
        batch(() => {
            dispatch(setLoading(false));
            dispatch(setError(error));
        });
    };

    const onComplete = (data) => {
        batch(() => {
            dispatch(setUser(data));
            dispatch(setLoading(false));
        });
    };

    try {
        const {
            jwtAccessToken, contactId, expiryDate, expiryInSeconds,
        } = loginData;
        const bearerAccessToken = `Bearer ${jwtAccessToken}`;

        if (document.cookie.indexOf('sinvest_jwt_token') === -1) {
            document.cookie = `sinvest_jwt_token=${bearerAccessToken};secure`;
            document.cookie = `client_id=${contactId};secure`;

            if (expiryDate) {
                document.cookie = `expiryDate=${expiryDate};secure`;
                document.cookie = `expiryInSeconds=${expiryInSeconds};secure`;
            }
        }

        dispatchContactId(contactId);
        setup({
            bearerAccessToken,
        });

        onComplete({
            contactId,
            memberToken: bearerAccessToken,
        });
    } catch (e: any) {
        stopWithException(e.message);
    }
};
